import { render, staticRenderFns } from "./_Notification-button.vue?vue&type=template&id=28fa076e&scoped=true&"
import script from "./_Notification-button.vue?vue&type=script&lang=js&"
export * from "./_Notification-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa076e",
  null
  
)

export default component.exports